import { useQuery } from "@tanstack/react-query";
import { adminGetMlParts } from "../queries";
import VideoMain from "../../video/VideoMain";

export default function PartSummary({
  partId,
  mlId,
}: {
  partId: number;
  mlId: number;
}) {
  const { data: mlParts } = useQuery(adminGetMlParts({ mlId, enabled: true }));

  const partData = mlParts?.filter((s) => s.id === partId)?.[0];

  return (
    <div className="h-64 shrink-0 border-b border-myGb/40 bg-black/60 flex overflow-auto">
      <div className="flex aspect-video border-r border-white/10">
        {partData?.video_url ? (
          <VideoMain
            setTime={() => { }}
            fitParent={true}
            url={"https://vimeo.com/" + partData?.video_url}
          />
        ) : (
          <div className="h-full w-full flex items-center text-center text-2xl justify-center">video yok</div>
        )}
      </div>
      <div className="flex-1 p-8 self-center">
        <div className="text-lg text-myOrange">
          {partData?.part_title} (id: {partData?.id})
        </div>
        <div>Alıştırma Süresi {partData?.practice_duration} dk</div>
        <div>Sıra {partData?.order}</div>
      </div>
    </div>
  );
}
